module.exports = __webpack_public_path__ + "static/media/foodsby-outline_black.4331960f.png";